<p>
  User logged out!
</p>
